export enum LoanInformationVariables {
  LoanAmount = 'Loan Amount',
  LoanType = 'Loan Type',
  LoanPurpose = 'Loan Purpose',
  OtherHomeImprovementType = 'Other Home Improvement(s) Type',
  BorrowerCellPhone = 'Borrower Cell Phone',
  BorrowerEmail = 'Borrower Email',
  ConfirmBorrowerEmail = 'Confirm Borrower Email',
  BorrowerDateOfBirth = 'Borrower Date of Birth',
  CoBorrowerCellPhone = 'Co-borrower Cell Phone',
  CoBorrowerEmail = 'Co-borrower Email',
  ConfirmCoBorrowerEmail = 'Confirm Co-borrower Email',
  CoBorrowerDateOfBirth = 'Co-borrower Date of Birth',
  FirstName = 'First Name',
  LastName = 'Last Name',
  HomeStreetAddress = 'Home Street Address',
  City = 'City',
  State = 'State',
  ZipCode = 'Zip Code',
  County = 'County',
  SSN = 'SSN',
  SessionId = 'SessionId',
  IsBorrowerManualFlow = 'IsBorrowerManualFlow',
  IsCoBorrowerManualFlow = 'IsCoBorrowerManualFlow',
  CoBorrowerFirstName = 'Co-Borrower First Name',
  CoBorrowerLastName = 'Co-Borrower Last Name',
  CoBorrowerSSN = 'Co-Borrower SSN',
  ProcessingStatusSetDate = 'Processing Status Set Date',
  AssignedConsultant = 'Assigned Consultant',
  AssignedProcessor = 'Assigned Processor',
  BorrowerChangedInfoAfterProvePreFill = 'BorrowerChangedInfoAfterProvePreFill',
  CoBorrowerChangedInfoAfterProvePreFill = 'CoBorrowerChangedInfoAfterProvePreFill',
  SwimmingPoolType = 'Swimming Pool Type',
  OwnershipStatus = 'Ownership Status',
  PurchaseDate = 'Purchase Date',
  FullConsentCheckbox = 'Full Consent Checkbox',
}
